(function() {
  var DialogController,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.RxWarningController = (function(superClass) {
    extend(RxWarningController, superClass);

    function RxWarningController(scope, transitions, modalInstance) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      RxWarningController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = 'Charge Confirmation';
      this.scope.absolute_errors = false;
    }

    return RxWarningController;

  })(DialogController);

}).call(this);
